export default class PaPayrollLineController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/paPayrollLine/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/add', 'post', params, axiosOption, httpOption);
  }

  static addList (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/addList', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/delete', 'post', params, axiosOption, httpOption);
  }

  static deleteBatch (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/deleteBatch', 'post', params, axiosOption, httpOption);
  }

  static startOnlyPaPayrollApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/startOnly/PaPayrollApprovalFlow', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyPaPayrollApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/startWithBusinessKey/PaPayrollApprovalFlow', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskPaPayrollApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/startAndTakeUserTask/PaPayrollApprovalFlow', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskPaPayrollApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/submitUserTask/PaPayrollApprovalFlow', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataPaPayrollApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/viewTaskBusinessData/PaPayrollApprovalFlow', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataPaPayrollApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/viewHistoricTaskBusinessData/PaPayrollApprovalFlow', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderPaPayrollApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollLine/listWorkOrder/PaPayrollApprovalFlow', 'post', params, axiosOption, httpOption);
  }
}
